module.exports = __webpack_public_path__ + "img/ys-sjt.f2edc5af.png";